import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core'
import { WorkInstructionSpec } from '../../process-plan'
import { BehaviorSubject } from 'rxjs'
import {
  CardOrganizerData,
  CardStack,
  ElderCardOrganizerComponent,
  ElderPaneActionsComponent,
  ElderPaneComponent,
  ElderPaneContentComponent,
  ElderPaneHeaderComponent,
  ElderPaneSubtitleComponent,
  ElderPaneTitleComponent,
  ElderStackCardDirective,
} from '@elderbyte/ngx-starter'
import { AttachmentSpec } from '../../../../attachments/spec/attachment-spec'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { AttachmentSpecDetailComponent } from '../../../../attachments/spec/attachment-spec-detail/attachment-spec-detail.component'
import { MatInput } from '@angular/material/input'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { FormsModule } from '@angular/forms'
import { MatIcon } from '@angular/material/icon'
import { MatIconButton } from '@angular/material/button'
import { AsyncPipe } from '@angular/common'
import { MatBadge } from '@angular/material/badge'

@Component({
  selector: 'app-instruction-detail',
  templateUrl: './instruction-detail.component.html',
  styleUrls: ['./instruction-detail.component.scss'],
  imports: [
    MatIconButton,
    MatIcon,
    MatBadge,
    FormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    ElderCardOrganizerComponent,
    ElderStackCardDirective,
    AttachmentSpecDetailComponent,
    AsyncPipe,
    ElderTranslatePipe,
    ElderPaneComponent,
    ElderPaneContentComponent,
    ElderPaneTitleComponent,
    ElderPaneSubtitleComponent,
    ElderPaneHeaderComponent,
    ElderPaneActionsComponent,
  ],
})
export class InstructionDetailComponent implements OnInit {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly instruction$ = new BehaviorSubject<WorkInstructionSpec>(null)

  public cardData: CardOrganizerData<AttachmentSpec>

  @Output()
  public readonly save: EventEmitter<Event> = new EventEmitter<Event>()

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnInit(): void {
    this.cardData = new CardOrganizerData<AttachmentSpec>([CardStack.newStack('default', '')])
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set instruction(spec: WorkInstructionSpec) {
    if (spec) {
      this.instruction$.next(spec)
      this.cardData.replaceStackCards('default', spec?.attachmentSpecs)
    }
  }

  public get instruction(): WorkInstructionSpec {
    return this.instruction$.getValue()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  /***************************************************************************
   *                                                                         *
   * Component Events                                                        *
   *                                                                         *
   **************************************************************************/

  public onSave($event: Event): void {
    this.instruction.attachmentSpecs = this.cardData.cards
    this.save.emit()
  }

  public onNewAttachmentSpecCard($event: CardStack<string, string>): void {
    this.cardData.addCard('default', new AttachmentSpec())
  }
}
